import React from 'react';

const TerminalEntryLine = ({children, line, offset}) => (
  <text
    className="home--console-text"
    x="25" y={60 + line * offset}
    fill="white"
  >
    {children}
  </text>
);
export const Terminal = ({entries = [], height = 100, width = 250} = {}) => {
  const entryElements = entries.map(({message, type}, index) => {
    const lineOptions = {
      key: index,
      line: index,
      offset: 20,
    };

    switch (type) {
      case 'input':
        return (
          <TerminalEntryLine {...lineOptions}>
            <tspan className="home--console-ps" fill="#7C69EF">$ </tspan>
            {message}
          </TerminalEntryLine>
        );

      case 'output':
        return (
          <TerminalEntryLine {...lineOptions}>
            {message}
          </TerminalEntryLine>
        );
      case 'newline':
        return (
          <TerminalEntryLine {...lineOptions} />
        );
      default:
        break;
    };
  });

  return (
    <svg
      height={height} width={width}
      version="1.1" xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0" y="10"
        rx="5" ry="5"
        height={height} width={width}
        fill="black" stroke="black"
      ></rect>

      <circle
        cx="20" cy="25" r="3"
        fill="red" stroke="red"
      />
      <circle
        cx="30" cy="25" r="3"
        fill="yellow" stroke="yellow"
      />
      <circle
        cx="40" cy="25" r="3"
        fill="green" stroke="green"
      />

      {entryElements}
    </svg>
  );
};
